import * as yup from 'yup'

export const getMaxLength = (id: string) => {
    switch (id) {
        case 'nameOfBusiness':
        case 'yourName':
        case 'titleOrRole':
            return 128
        case 'phone':
            return 25
        case 'comments':
            return 1000
        case 'email':
            return 49
        default:
            return 100
    }
}

export const validationSchema = {
    yourName: yup.string().min(1, 'Name is invalid.').max(128, 'Name is invalid.').required('Name is required.'),
    nameOfBusiness: yup
        .string()
        .min(1, 'Business Name is invalid.')
        .max(128, 'Business Name is invalid.')
        .required('Name of Business is required.'),
    titleOrRole: yup
        .string()
        .min(1, 'Title or Role is invalid.')
        .max(128, 'Title or Role is invalid.')
        .required('Title or Role is required.'),
    email: yup
        .string()
        .matches(/^[a-zA-Z0-9_.+-]+@[a-zA-Z-]+\.[a-zA-Z-.]+$/, 'Email ID is invalid.')
        .email('Email ID is invalid.')
        .required('Email ID is required.'),
    phone: yup
        .string()
        .test('phone', 'Phone is invalid.', (value: any) => {
            const numeralValue = value.replace(/\D/g, '')
            return numeralValue.length >= 5 && numeralValue.length <= 18
        })
        .matches(/^[0-9 ()-]+$/, 'Phone is invalid.')
        .required('Phone is required.'),
    comments: yup.string().required('Comments required.')
}

const formatPhoneNumber = (phoneCode: string, phone: string): string => {
    const value = phoneCode.split(':', 1)[0] + phone.replace(/[^+\d]+/g, '')
    return value
}

export const mapToRequestDemo = (payload) => ({
    branchCountryCode: payload.branchCountryCode,
    browserName: payload.browserName,
    browserVersion: payload.browserVersion,
    carrier: 'CPS',
    country: payload.businessCountry,
    description: payload.comments,
    email: payload.email,
    function: 'Request for Demo',
    name: payload.yourName,
    nameOfBusiness: payload.nameOfBusiness,
    phone: '+' + formatPhoneNumber(payload.phoneCode, String(payload.phone)),
    role: payload.describeYourRole,
    titleOrRole: payload.titleOrRole,
    userID: payload.userID
})

export function getUserDetails (login: any) {
    if (login?.loginDetails?.securityParams?.userID != null) {
        return {
            userID: login.loginDetails.securityParams.userID,
            branchCountryCode: login.loginDetails.securityParams.branchCountryCode
        }
    } else {
        return {
            userID: 'CPS Guest',
            branchCountryCode: ''
        }
    }
}
